var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('v-main',[_c('v-container',{staticClass:"main-body pa-0"},[_c('v-col',{staticClass:"text-center pa-0"},[_c('v-img',{attrs:{"src":require("./assets/2026-challenge-header.png")}})],1),_c('div',{staticClass:"pa-8 pt-0"},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }